import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { StepComponent } from '@app/components';
import { ApplicantAttachment } from '@app/models/recruiting/applicant-attachments.model';
import { JobAttachment } from '@app/models/recruiting/job-attachments.model';
import { ApplicantStoreUploadForm } from '@app/modules/forms/applicant-tracker/components';
import { AuthService, NotifyService } from '@app/services';
import { StoreView } from '@common/views';
import { Applicant } from '@models/recruiting/applicant.model';

@Component({
    templateUrl: './applicant-store.template.html',
    styleUrls: ['./applicant-store.style.scss'],
})
export class ApplicantStoreView extends StoreView {
    @ViewChild('uploadForm') uploadForm: ApplicantStoreUploadForm;

    isLoading = false;
    applicant: Applicant;

    constructor(
        private notify: NotifyService,
        private auth: AuthService,
        private router: Router
    ) {
        super();
        this.applicant = new Applicant();
        this.applicant.referrer = 'Humi';
        this.applicant.rating = 0;
    }

    async onNextStep([currentStep]: [StepComponent, number]): Promise<void> {
        // Based on the current step
        switch (currentStep.step) {
            case 'Upload Document':
                this.isLoading = true;
                await this.uploadForm.loadJobAttachments();
                this.isLoading = false;
                break;
        }
    }

    async onSave(): Promise<void> {
        try {
            this.isLoading = true;
            const applicant: Applicant = await this.applicant.param('company', this.auth.company.id).save();

            await Promise.all(
                this.uploadForm.jobAttachments.map(async (jobAttachment: JobAttachment) => {
                    if (jobAttachment.fileId || jobAttachment.link) {
                        const newApplicantAttachment: ApplicantAttachment = new ApplicantAttachment({
                            applicantId: applicant.id,
                            jobAttachmentId: jobAttachment.id,
                            fileId: jobAttachment.fileId ? jobAttachment.fileId : undefined,
                            content: jobAttachment.link ? jobAttachment.link : undefined,
                        });

                        return newApplicantAttachment.save();
                    }
                })
            );

            this.notify.success('applicant-tracker.applicants.create.success');
            this.router.navigate(['/recruiting', 'applicants', this.applicant.id]);
        } catch (err) {
            this.notify.error(err.message || 'applicant-tracker.applicants.create.error');
            this.isLoading = false;
        }
    }
}
